__turbopack_context__.v({
  "button": "PasswordVisibilityIcon-module-scss-module__MaVIsG__button",
});
